import { type UseMediaCaptureParams, useMediaCapture as useSharedMediaCapture } from '@/hooks/inspectionMedia/useMediaCapture'
import { MESSAGES } from '@/pages/return/rgr11V2/constants'

/**
 * 웹캠 촬영·녹화 — 본체는 공용 훅(`@/hooks/inspectionMedia/useMediaCapture`, 입고작업 2.0 GL17 과 같이 쓴다).
 * 이 경로는 기존 import·`vi.mock` 경로를 지키려고 남긴다. 반품 화면 문구만 여기서 넘긴다.
 */
export type { CapturedFile, UseMediaCaptureParams } from '@/hooks/inspectionMedia/useMediaCapture'

export const useMediaCapture = (params: UseMediaCaptureParams) => useSharedMediaCapture({ cameraUnavailableMessage: MESSAGES.cameraUnavailable, ...params })
